import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useGetApiQuery } from "../../../../redux/services/apiHome";
import Loader from "../../../../components/Loader";
import InnerBannerBreadcrumb from "../../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import usePagination from "../../../../hooks/usePagination";
import Pagination from "../../../../components/Pagination/Pagination";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../../redux/services/apiSlice";
import { extractDate, extractDateFromStr } from "../../../../Utils/utils";
import PageLastUpdated from "../../../../components/shared/PageLastUpdated";
import PhotoGalleryDetail from "./PhotoGalleryDetail";

const PhotoGalleryDetailPage = () => {
  const { getText } = useLanguageTranslation();

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Photo Gallery", "फोटो गैलरी")}
        titleLink="/publication-detail"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Photo Gallery", "फोटो गैलरी")}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <PhotoGalleryDetail />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PhotoGalleryDetailPage;
